import Api from './Api'

class Workflow extends Api {

  constructor(version = 'v1') {
    super(version)
    this.path = 'workflows'
  }

  async duplicate(workflow_id) {
    try {
      let response = await this.http.put(this.path + '/' + workflow_id + '/clone')
      return response.data
    } catch(err) {
      this.handleError(err)
      return err
    }
  }

  async trigger(workflow_id) {
    try {
      let response = await this.http.post(this.path + '/' + workflow_id + '/trigger')
      return response.data
    } catch(err) {
      this.handleError(err)
      return err
    }
  }
}

export default Workflow



// WEBPACK FOOTER //
// ./src/api/Workflow.js